export default __webpack_public_path__ + "static/media/lawn-doctors-certifications-homestars.ea7dfd65.svg";